"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vueRoot = vueRoot;
function vueRoot(component) {
    return component.$root;
}
